import { useTranslations } from '@vocab/react';
import { Stack, Box, Heading } from 'braid-design-system';

import ThreadCard from 'src/components/molecules/Shared/ThreadCard/ThreadCard';
import { useThreads } from 'src/provider/threads';

import translations from './.vocab';

export default () => {
  const { t } = useTranslations(translations);
  const {
    threadsState: { displayThreads },
  } = useThreads();

  return (
    <Box display="flex" flexDirection="column">
      <Box paddingBottom="large" paddingRight="small" paddingTop="medium">
        <Heading level="3" weight="regular">
          {t('featuredThreads')}
        </Heading>
      </Box>
      <Stack space="small">
        {displayThreads.map((thread) => (
          <ThreadCard key={thread.id} thread={thread} isFeatured={true} />
        ))}
      </Stack>
    </Box>
  );
};
